/**
 * Shared image upload validation constants and utility.
 *
 * Every component that accepts image uploads should import from here
 * instead of defining its own size limits and allowed types. This
 * keeps the rules in one place so client and server stay in sync.
 */

/** Maximum allowed image file size in bytes (5 MB). */
export const MAX_IMAGE_FILE_SIZE = 5 * 1024 * 1024;

/** MIME types accepted for image uploads. */
export const ALLOWED_IMAGE_TYPES = [
    'image/jpeg',
    'image/jpg',
    'image/png',
    'image/heic',
    'image/heif',
];

/**
 * File extensions string for the HTML `accept` attribute on file inputs.
 * Limits the browser's file picker to the supported types.
 */
export const ACCEPTED_FILE_EXTENSIONS = '.jpg,.jpeg,.png,.heic,.heif';

/**
 * Validate an image file's type and size.
 *
 * @param {File} file - The file object from an <input type="file"> element.
 * @returns {string|null} An error message string if validation fails, or null if the file is valid.
 */
export function validateImageFile(file) {
    if (!ALLOWED_IMAGE_TYPES.includes(file.type)) {
        return 'Invalid file type. Please select a JPEG, PNG, or HEIC image.';
    }
    if (file.size > MAX_IMAGE_FILE_SIZE) {
        return 'File size exceeds 5MB. Please select a smaller image.';
    }
    return null;
}
